
export const services = [
    {
        id:1,
        title: "Technology Enthusiast",
        icon: 'https://csgeeek.github.io/web.png',
    },
    {
        id:2,
        title: "Software Engineer",
        icon: 'https://csgeeek.github.io/web.png',
    },
    
];

export const name = 'Gaurav';

export const experiences = [
    {
        'company': 'Surmount Energy Solutions (Maxval Technologies)',
        'role': 'Software Developer',
        'duration': 'July 2022 - Present',
        'points': [
            'Involved in dynamic contributions to web and mobile📱 development projects, actively influencing and improving project outcomes.',
            'Developed multiple shared components to simplify tasks for fellow developers, boosting efficiency and teamwork.',
            'Enhanced product performance through significant contributions to backend development, optimizing essential components for improved efficiency 📈.',
            'Implemented data security for the company’s product to provide role-based access control ⚙️.'
        ],
        
    },
    
]



export const EMAIL_JS_SERVICE_ID = 'service_90wb9t5';
export const EMAIL_JS_TEMPLATE_ID = 'template_8l87rew';
export const EMAIL_JS_PUBLIC_KEY = 'pHPjc9RGGkF66r86N';